/**
 * PlaceholderWidget — temporary fill for widgets whose real component
 * hasn't been built yet. Each subsequent FE phase replaces a subset of
 * these placeholders with a real widget component.
 *
 * Renders the catalog's `display` JSON so devs (and stakeholders) can
 * see what data the BE is feeding the widget while we wire the UI.
 */

import * as React from "react";
import { WidgetCard } from "components/dashboard";
import type { LayoutItem, WidgetConfig } from "../types";

export function PlaceholderWidget({
  widget,
  layout,
}: {
  widget: WidgetConfig;
  layout: LayoutItem;
}) {
  return (
    <WidgetCard
      title={widget.title}
      w={widget.defaultSize.w}
      h={widget.defaultSize.h}
      x={layout.x}
      y={layout.y}
    >
      <div className="text-xs text-gray-500">
        <div className="mb-1">Coming soon</div>
        <details className="mt-2">
          <summary className="cursor-pointer text-gray-400">config</summary>
          <pre className="mt-2 text-[10px] bg-gray-50 p-2 rounded overflow-auto max-h-32">
            {JSON.stringify(widget.display, null, 2)}
          </pre>
        </details>
      </div>
    </WidgetCard>
  );
}
